// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H_xtMVhRDLEDSVmk{max-width:400px}.PDWRhzEBR4XhghqF{margin-top:10px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"peopleInputContainer": `H_xtMVhRDLEDSVmk`,
	"peopleChips": `PDWRhzEBR4XhghqF`
};
export default ___CSS_LOADER_EXPORT___;
